<script setup></script>

<template>
<Teleport to="body">
  <transition name="modal">
    <div class="fixed top-0 right-0 bottom-0 left-0 z-[9999] flex items-center justify-center bg-black/70">
      <div class="text_all relative flex max-h-[80vh] w-9/12 flex-col gap-4 overflow-y-auto rounded bg-white px-3 pt-2.5 pb-[30px]">
        <button class="flex justify-end" @click="$emit('close')">
          <img src="../assets/close.svg" width="24" height="24" alt="" />
        </button>
        <div class="text-center text-base font-bold text-black">
          <slot name="title"></slot>
        </div>
        <div class="text-sm font-normal text-black">
          <slot name="description"></slot>
        </div>
        <slot name="footer"></slot>
      </div>
    </div>
  </transition>
</Teleport>
</template>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s ease;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>
